// extracted by mini-css-extract-plugin
module.exports = {"marginRight":"components_marginRight__aMGlC"};